import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisH, faSync } from '@fortawesome/free-solid-svg-icons';
import "./TablePurchase.css"
import Loader from "../Loader";
import ModulesModal from "../ModulesModal";
import SubscriptionsModule from "../SubscriptionsModule";
import ComboModal from "../ComboModal";
import PoliciesModal from "../PoliciesModal";
import Pagination from "../Table/pagination";

const TablePurchase = ({
    title,
    rows = [],
    columns = [],
    renderRow,
    icon,
    currentPage,
    totalItems,
    itemsPerPage,
    onPageChange,
    onRowClick,
    selectedRow,
    onRefresh,
    loading,
    flagPagination,
    selectedModules,
    setSelectedModules,
    onMergeRows,
}) => {

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubscriptionModalOpen, setSubscriptionIsModalOpen] = useState(false);
    const [isComboModalOpen, setComboIsModalOpen] = useState(false);
    const [isPolizaModalOpen, setPolizaIsModalOpen] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const toggleDropdown = () => setShowDropdown(!showDropdown);

    const handleOptionClick = (action) => {
        setShowDropdown(false);
        action();
    };

    // Cierra el menú si se hace clic fuera de él
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Usamos useCallback para memorizar mergeDataWithSelectedModules
    const mergeDataWithSelectedModules = useCallback(() => {
        const updatedData = [...rows];
        selectedModules.forEach(selected => {
            const index = updatedData.findIndex(item => item.moduleId === selected.moduleId);
            if (index !== -1) {
                updatedData[index] = selected;
            } else {
                updatedData.push(selected);
            }
        });

        return updatedData;
    }, [rows, selectedModules]); // Añadimos rows y selectedModules como dependencias

    const mergedRows = useMemo(() => mergeDataWithSelectedModules(), [mergeDataWithSelectedModules]);

    const paginatedRows = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return mergedRows.slice(start, start + itemsPerPage);
    }, [mergedRows, currentPage, itemsPerPage]);

    useEffect(() => {
        if (onMergeRows) {
            onMergeRows(mergedRows);
        }
    }, [mergedRows, onMergeRows]);

    const closeModal = () => {
        setIsModalOpen(false);
    };
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeSubscriptionModal = () => {
        setSubscriptionIsModalOpen(false);
    };
    const openSubscriptionModal = () => {
        setSubscriptionIsModalOpen(true);
    };

    const closeComboModal = () => {
        setComboIsModalOpen(false);
    };
    const openComboModal = () => {
        setComboIsModalOpen(true);
    };

    const openPolizaModal = () => {
        setPolizaIsModalOpen(true);
    };
    const closePolizaModal = () => {
        setPolizaIsModalOpen(false);
    };

    const handleAddModules = (newModules, productType) => {
        setSelectedModules((prevModules) => {
            const globalWithoutCategory = prevModules.filter(
                (module) => module.productType !== productType
            );
            // se fusionan con los nuevos módulos de la categoría
            return [...globalWithoutCategory, ...newModules];
        });
        closeModal();
        closeSubscriptionModal();
        closeComboModal();
        closePolizaModal();
    };


    return (
        <div className="purchase-table-container2">
            <div className="sales-table-header2">
                <div className="header-left2">
                    <div className="icon-container-table">
                        <FontAwesomeIcon icon={icon} className="icon" />
                    </div>
                    <FontAwesomeIcon
                        icon={faSync}
                        className="shortcut-icon-actually"
                        onClick={onRefresh}
                        style={{ cursor: 'pointer' }}
                    />
                    <h3>{title}</h3>
                </div>
                <div className="dropdown-container" ref={dropdownRef}>
                    <div className="dropdown-container-table">
                        <button
                            className="icon-button dropdown-button-table"
                            onClick={toggleDropdown}>
                            <FontAwesomeIcon icon={faEllipsisH} />
                        </button>
                        {showDropdown && (
                            <div className="dropdown-menu-table">
                                <button
                                    className="dropdown-item-table"
                                    onClick={() => handleOptionClick(openModal)}>
                                    Módulos Extras
                                </button>
                                <button
                                    className="dropdown-item-table"
                                    onClick={() => handleOptionClick(openSubscriptionModal)}>
                                    Suscripciones
                                </button>
                                <button
                                    className="dropdown-item-table"
                                    onClick={() => handleOptionClick(openComboModal)}>
                                    Combos
                                </button>
                                <button
                                    className="dropdown-item-table"
                                    onClick={() => handleOptionClick(openPolizaModal)}>
                                    Pólizas
                                </button>
                            </div>
                        )}
                    </div>
                </div>

            </div>
            <table className="sales-table">
                <thead>
                    <tr>
                        {columns.map((col, index) => (
                            <th key={index}>{col.title}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {

                        loading ? (
                            <tr>
                                <td colSpan={columns.length} className="loader-container">
                                    <Loader />
                                </td>
                            </tr>
                        ) : paginatedRows.length > 0 ? (
                            paginatedRows.map((item, index) => (
                                <tr
                                    key={item.id || index}
                                    onClick={() => onRowClick && onRowClick(item)}
                                    className={item === selectedRow ? "selected-row" : ""}
                                >
                                    {renderRow(item, index)}
                                    {columns.map((col) => col.render && <td key={col.key}>{col.render(item)}</td>)}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length} className="no-data">No existen datos</td>
                            </tr>
                        )}
                </tbody>
            </table>
            {isModalOpen && (
                <ModulesModal
                    isVisible={isModalOpen}
                    onClose={() => closeModal()}
                    onAddModules={handleAddModules}
                    //initialSelectedModules={selectedModules}
                    initialSelectedModules={selectedModules.filter(mod => mod.productType === "EXTRAS")}
                />
            )}
            {isSubscriptionModalOpen && (
                <SubscriptionsModule
                    isVisible={isSubscriptionModalOpen}
                    onClose={() => closeSubscriptionModal()}
                    onAddModules={handleAddModules}
                    //initialSelectedModules={selectedModules}
                    initialSelectedModules={selectedModules.filter(mod => mod.productType === "SUBSCRIPTIONS")}
                />
            )}
            {isComboModalOpen && (
                <ComboModal
                    isVisible={isComboModalOpen}
                    onClose={() => closeComboModal()}
                    onAddModules={handleAddModules}
                    //initialSelectedModules={selectedModules}
                    initialSelectedModules={selectedModules.filter(mod => mod.productType === "COMBOS")}
                />
            )}
            {isPolizaModalOpen && (
                <PoliciesModal
                    isVisible={isPolizaModalOpen}
                    onClose={() => closePolizaModal()}
                    onAddModules={handleAddModules}
                    //initialSelectedModules={selectedModules}
                    initialSelectedModules={selectedModules.filter(mod => mod.productType === "POLIZAS")}
                />
            )}
            {!loading && flagPagination && (
                <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={onPageChange}
                />
            )}
        </div>
    );
};

export default TablePurchase;